import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { RelocationType } from '../../enum';
import { EducationReimbursement, StateLicensureReimbursement } from '../../models';

export const ReimbursementsActions = createActionGroup({
    source: 'Margin Calculator - Reimbursements & Bonuses',
    events: {
        revealReimbursementsDetailsClicked: emptyProps(),
        loadReimbursements: emptyProps(),
        setRelocationType: props<{ relocationType: RelocationType }>(),
        setRelocationBeginning: props<{ relocationTo: number }>(),
        setRelocationEnd: props<{ relocationFrom: number }>(),
        setLicenses: props<{ licenses: StateLicensureReimbursement[] }>(),
        setCertifications: props<{ certifications: EducationReimbursement[] }>(),
        licenseSelected: (code: string) => ({ code }),
        licenseUnselected: (code: string) => ({ code }),
        certificationSelected: props<{ id: number }>(),
        certificationUnselected: props<{ id: number }>(),
        setLicenseAmount: props<{ code: string; amount: number }>(),
        setCertificationName: props<{ id: number; name: string }>(),
        setCertificationAmount: props<{ id: number; amount: number }>(),
        setOneTimeCarRental: props<{ amount: number }>(),
        setOneTimeFingerprinting: props<{ amount: number }>(),
        setOneTimeParking: props<{ amount: number }>(),
        setOneTimeScrubs: props<{ amount: number }>(),
        setOneTimeTaxable: props<{ amount: number }>(),
        setMonthlyCarRental: props<{ amount: number }>(),
        setMonthlyParking: props<{ amount: number }>(),
        setFacilityPaidBonus: props<{ amount: number }>(),
        setAyaPaidBonus: props<{ amount: number }>(),
        setDiscretionaryBonus: props<{ amount: number }>(),
        setReferralBonus: props<{ amount: number }>(),
        setPayTo: props<{ payTo: string }>(),
        setForReferring: props<{ forReferring: string }>(),
        setHasOneTimeCustomReimbursement: emptyProps(),
        setOneTimeCustomReimbursementTitle: props<{ title: string }>(),
        setOneTimeCustomReimbursementAmount: props<{ amount: number }>(),
        setHasMonthlyCustomReimbursement: emptyProps(),
        setMonthlyCustomReimbursementTitle: props<{ title: string }>(),
        setMonthlyCustomReimbursementAmount: props<{ amount: number }>(),
        setSelectedPickle: props<{ controlName: string; amount: number }>(),
        removeSelectedPickle: emptyProps(),
        setPickledAmount: props<{ amount: number }>()
    }
});
